/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminPromotionDto,
  AdminPromotionImageDto,
  AdminPromotionRequestDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminPromotionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name GetPromotion1
   * @summary Get Promotion by ID
   * @request GET:/v1/admin/promotions/{promotionId}
   * @secure
   */
  getPromotion1 = (promotionId: number, params: RequestParams = {}) =>
    this.http.request<AdminPromotionDto, any>({
      path: `/v1/admin/promotions/${promotionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name UpdatePromotion
   * @summary Update a Promotion
   * @request PUT:/v1/admin/promotions/{promotionId}
   * @secure
   */
  updatePromotion = (
    promotionId: number,
    data: AdminPromotionRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminPromotionDto, any>({
      path: `/v1/admin/promotions/${promotionId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name DeletePromotion
   * @summary Delete a Promotion
   * @request DELETE:/v1/admin/promotions/{promotionId}
   * @secure
   */
  deletePromotion = (promotionId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/promotions/${promotionId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name GetPromotions1
   * @summary Get Promotions
   * @request GET:/v1/admin/promotions
   * @secure
   */
  getPromotions1 = (
    query?: {
      isActive?: boolean;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminPromotionDto[], any>({
      path: `/v1/admin/promotions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name CreatePromotion
   * @summary Create a Promotion
   * @request POST:/v1/admin/promotions
   * @secure
   */
  createPromotion = (data: AdminPromotionRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminPromotionDto, any>({
      path: `/v1/admin/promotions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name GetPromotionImages
   * @summary Get Images for a Promotion
   * @request GET:/v1/admin/promotions/{promotionId}/images
   * @secure
   */
  getPromotionImages = (
    promotionId: number,
    query?: {
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["seq,ASC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminPromotionImageDto[], any>({
      path: `/v1/admin/promotions/${promotionId}/images`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name CreatePromotionImage
   * @summary Create a Image
   * @request POST:/v1/admin/promotions/{promotionId}/images
   * @secure
   */
  createPromotionImage = (
    promotionId: number,
    query: {
      /** @format int32 */
      seq: number;
    },
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminPromotionImageDto, any>({
      path: `/v1/admin/promotions/${promotionId}/images`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromotionService
   * @name DeletePromotionImage
   * @summary Delete a Promotion Image
   * @request DELETE:/v1/admin/promotions/{promotionId}/images/{promotionImageId}
   * @secure
   */
  deletePromotionImage = (
    promotionId: number,
    promotionImageId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/promotions/${promotionId}/images/${promotionImageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
